import apiClient from './client';

// export async function submitScripApplication(payload, photoFile = null) {
//   if (photoFile) {
//     const formData = new FormData();
//     formData.append('identity',   JSON.stringify(payload.identity));
//     formData.append('legal',      JSON.stringify(payload.legal));
//     formData.append('employment', JSON.stringify(payload.employment));
//     formData.append('education',  JSON.stringify(payload.education));
//     formData.append('photo',      photoFile, photoFile.name);
//     const response = await apiClient.postForm('/scrip/apply', formData);
//     return response.data;
//   }
//   const response = await apiClient.post('/scrip/apply', payload);
//   return response.data;
// }

// REPLACE the entire submitScripApplication function with this:

export async function submitScripApplication(payload, photoFile = null) {
  // Always send as JSON — photo upload handled separately if needed
  const response = await apiClient.post('/scrip/apply', payload);
  return response.data;
}

export async function getScripStatus(referenceCode) {
  const response = await apiClient.get(`/scrip/status/${encodeURIComponent(referenceCode)}`);
  return response.data;
}

// ── Admin only ────────────────────────────────────────────────────────────────

export async function listScripApplications(params = {}) {
  const qs = new URLSearchParams(
    Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== ''))
  ).toString();
  const response = await apiClient.get(`/scrip/applications${qs ? `?${qs}` : ''}`);
  return response.data;
}

export async function getScripApplication(id) {
  const response = await apiClient.get(`/scrip/applications/${id}`);
  return response.data;
}

export async function updateScripStatus(id, update) {
  const response = await apiClient.patch(`/scrip/applications/${id}/status`, update);
  return response.data;
}